/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/util',['require','jquery','underscore','modernizr'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var Modernizr = require('modernizr');

  /*****************************************************************************************************************/ //}

  var Utilities = {

    ////////////////
    // PROPERTIES /{
    ////////////////

    animationEnd: 'animationend mozAnimationEnd webkitAnimationEnd oanimationend MSAnimationEnd',

    /*****************************************************************************************************************/ //}

    /////////////
    // METHODS /{
    /////////////

    jqueryPatch: function()
    {
      $.fn.refresh = function()
      {
        var self = this;

        //self.hide();
        self.css('opacity', '0.99');
        return setTimeout(function()
        {
          self.css('opacity', '1');
          //self.show();
          return self;
        }, 50);
      };

      $.fn.animateRotate = function(angle, duration, easing, complete)
      {
        return this.each(function()
        {
          var elem = $(this);
          var startVal = Utilities.getRotationDegrees(elem);

          $({ deg: startVal }).animate({ deg: angle }, {
            duration: duration,
            easing: easing,
            step: function(now)
            {
              elem.css({
                transform: 'rotate(' + now + 'deg)'
              });
            },
            complete: complete || $.noop
          });
        });
      };

      $.fn.animateScale = function(value, duration, easing, complete)
      {
        return this.each(function()
        {
          var elem = $(this);
          var startVal = Utilities.getScalePercent(elem);

          $({ scale: startVal.x }).animate({ scale: value }, {
            duration: duration,
            easing: easing,
            step: function(now)
            {
              elem.css({
                transform: 'scale(' + now + ', ' + now + ')'
              });
            },
            complete: complete || $.noop
          });
        });
      };

      $.fn.animateBlur = function(amount, duration, easing, complete)
      {
        return this.each(function()
        {
          var elem = $(this);
          var startVal = elem.data('blur') || 0;
          elem.data('blur', amount);

          $({ blur: startVal }).animate({ blur: amount }, {
            duration: duration,
            easing: easing,
            step: function(now)
            {
              elem.css({
                '-webkit-filter': 'blur(' + now + 'px)',
                '-ms-filter': 'blur(' + now + 'px)',
                '-o-filter': 'blur(' + now + 'px)',
                '-moz-filter': 'blur(' + now + 'px)',
                'filter': 'progid:DXImageTransform.Microsoft.Blur(PixelRadius="' + now + '")'
              });
            },
            complete: complete || $.noop
          });
        });
      };

      $.fn.shuffle = function()
      {
        var allElems = this.get();

        var getRandom = function(max)
        {
          return Math.floor(Math.random() * max);
        };

        var shuffled = $.map(allElems, function()
        {
          var random = getRandom(allElems.length);
          var randEl = $(allElems[random]).clone(true)[0];
          allElems.splice(random, 1);
          return randEl;
        });

        this.each(function(i)
        {
          $(this).replaceWith($(shuffled[i]));
        });

        return $(shuffled);
      };

      $.fn.cssAnimate = function(animation, onComplete, fallback)
      {
        animation = animation || '';
        onComplete = onComplete || $.noop;

        if (!Modernizr.csstransitions) // use fallback
        {
          if (fallback)
          {
            this[fallback](250, onComplete);
          }
          else if (animation.toLowerCase().indexOf('in') >= 0)
          {
            this.fadeIn(250, onComplete);
          }
          else if (animation.toLowerCase().indexOf('out') >= 0)
          {
            this.fadeOut(250, onComplete);
          }

          return this;
        }

        // remove old animation (if exists)
        this.removeClass(this.attr('data-transition'));

        // add complete handler
        this.on(Utilities.animationEnd, function(e)
        {
          // unbind complete handler
          $(this).off(Utilities.animationEnd);

          // remove animation class
          $(this).removeClass('animated ' + animation);

          // fire complete callback
          $.proxy(onComplete, $(this), e)();
        });

        this.attr('data-transition', animation);

        this.addClass('animated hw-accel');
        this.addClass(animation);

        return this;
      };

      $.fn.blur = function(amount)
      {
        $(this).css({
          '-webkit-filter': 'blur(' + amount + 'px)',
          '-ms-filter': 'blur(' + amount + 'px)',
          '-o-filter': 'blur(' + amount + 'px)',
          '-moz-filter': 'blur(' + amount + 'px)',
          'filter': 'progid:DXImageTransform.Microsoft.Blur(PixelRadius="' + amount + '")'
        });

        $(this).data('blur', amount);

        return $(this);
      };
    },

    getTypedValue: function(value)
    {
      var retVal = null;

      if (value === '')
      {
        retVal = value; // set as empty string
      }
      else if (value === 'true' || value === 'on' || value === true)
      {
        retVal = true; // set as true Boolean
      }
      else if (value === 'false' || value === 'off' || value === false)
      {
        retVal = false; // set as false Boolean
      }
      else if (!isNaN(Number(value, 10)))
      {
        retVal = Number(value); // set as a Number
      }
      else if (isNaN(Number(value, 10)))
      {
        retVal = value; // set as a string
      }

      return retVal;
    },

    getItemNumber: function(itemName)
    {
      if (!itemName)
        return;

      var arr = itemName.split('');
      var num = '';

      $.each(arr, function(index, value)
      {
        if (!isNaN(parseInt(value, 10)))
          num += value.toString();
      });

      return parseInt(num, 10);
    },

    stripHTML: function(text)
    {
      return text.replace(/(<([^>]+)>)/ig, '');
    },

    addslashes: function(str)
    {
      return str.replace(/[!@#\$%\^&\*\(\)\+=-\[\]\\';,\.\/\{\}\|':<>\?~_]/g, '\\$&');
    },

    getLetter: function(index, capital)
    {
      index += 97;
      if (capital)
        index -= 32;

      return String.fromCharCode(index);
    },

    animateNumericText: function(div, end, currency, speed, callback)
    {
      if (!div)
        return;

      if (_.isUndefined(speed))
        speed = 20;

      callback = callback || $.noop;

      var currentText = div.text();
      if (currentText)
        currentText = currentText.replace(/[^\d]/g, '');

      var currentValue = parseFloat(currentText);

      if (isNaN(currentValue))
        currentValue = 0;

      var difference = end - currentValue;

      if (difference === 0)
      {
        div.html(currentValue);
        return;
      }

      var inc = (difference > 0) ? 1 : -1;
      difference = Math.abs(end - currentValue);

      setTimeout(animateText, speed);

      function animateText ()
      {
        var mult = 1;

        if (currentValue === end)
        {
          callback();
          return;
        }
        else
        {
          difference = Math.abs(end - currentValue);

          if (difference > 1000)
            mult = 100;
          else if (difference > 100)
            mult = 10;
          else if (difference > 10)
            mult = 5;
        }

        currentValue += (inc * mult);

        var value = currentValue.toString();

        if (currency)
          value = '$' + value;

        div.html(value);

        setTimeout(animateText, speed);
      }
    },

    formatTime: function(time, hours, minutes, seconds, milliseconds)
    {
      // multiply by 1000 because Date() requires milliseconds
      var date = new Date(time);
      var hh = date.getHours();
      var mm = date.getMinutes();
      var ss = date.getSeconds();
      var ms = date.getMilliseconds();

      // This line gives you 12-hour (not 24) time
      //if (hh > 12) {hh = hh - 12;}

      // These lines ensure you have two-digits
      if (hh < 10)
        hh = '0' + hh;
      if (mm < 10)
        mm = '0' + mm;
      if (ss < 10)
        ss = '0' + ss;
      if (ms < 100)
        ms = '0' + ms;
      if (ms < 10)
        ms = '0' + ms;

      var result = [];

      if (hours !== false)
        result.push(hh);
      if (minutes !== false)
        result.push(mm);
      if (seconds !== false)
        result.push(ss);
      if (milliseconds !== false)
        result.push(ms);

      return result.join(':');
    },

    getOrdinal: function(num, superscript)
    {
      if ((parseFloat(num) === parseInt(num)) && !isNaN(num))
      {
        var s = ['th', 'st', 'nd', 'rd'];
        var v = num % 100;
        var ord = (s[(v - 20) % 10] || s[v] || s[0]);

        if (superscript)
          num += '<sup>' + ord + '</sup>';
        else
          num = ord;
      }

      return num;
    },

    getRotationDegrees: function(obj)
    {
      var matrix = obj.css('-webkit-transform') ||
        obj.css('-moz-transform') ||
        obj.css('-ms-transform') ||
        obj.css('-o-transform') ||
        obj.css('transform');

      var angle = 0;

      if (matrix !== 'none')
      {
        var values = matrix.split('(')[1].split(')')[0].split(',');
        var a = values[0];
        var b = values[1];
        angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
      }

      return (angle < 0) ? angle += 360 : angle;
    },

    getScalePercent: function(obj)
    {
      var matrix = obj.css('-webkit-transform') ||
        obj.css('-moz-transform') ||
        obj.css('-ms-transform') ||
        obj.css('-o-transform') ||
        obj.css('transform');

      var scale = {
        x: 1,
        y: 1
      };

      if (matrix !== 'none' && matrix.length > 1)
      {
        var values = matrix.split('(')[1].split(')')[0].split(',');
        scale.x = parseFloat(values[0]);
        scale.y = parseFloat(values[3]);
      }

      return scale;
    },

    getQueryParameters: function(str)
    {
      return (str || document.location.search).replace(/(^\?)/, '').split('&').map(
        function(n) {
          return n = n.split('='), this[n[0]] = n[1], this;
        }.bind({})
      )[0];
    }

    /*****************************************************************************************************************/ //}

  };

  return Utilities;

});

